module.exports = {
  address: "0x3457E7FA54E300c5a8518fA780633909ddFD5Bc0",
  abi: require("./ClaimH.abi.json"),
};
